export default __webpack_public_path__ + "static/media/german.01ac7501.png";